import { useEffect } from 'react'
import type { Loan } from '@/types'
import { useDealDossierStore } from '@/store/dealDossierStore'
import type { EditableLoanPatch } from './types'

/**
 * Compatibility entry point. The deal workspace is the Record page of the
 * Property Dossier — this modal only forwards the pipeline row into that
 * template so there is a single accumulating file per deal.
 */
export function DealWorkspaceModal({
  loan,
  onClose,
}: {
  loan: Loan
  allLoans?: Loan[]
  saving?: boolean
  onClose: () => void
  onSave?: (patch: EditableLoanPatch) => Promise<void>
}) {
  useEffect(() => {
    useDealDossierStore.getState().openDossier(loan.id, 'overview', loan)
    onClose()
  }, [loan, onClose])
  return null
}
